module.exports = __webpack_public_path__ + "static/media/colors_bar.074f3d10.svg";